import { ForwardToPartnersContent } from './action-node-content/forward-to-partners-content';
import {
  ActionTypeContentLibrary,
  ActionTypeOption,
  ActionTypePayloadConfig,
} from './action-node-editor.types';

export const actionTypeOptions: ActionTypeOption[] = [
  { label: 'Forward to partners', value: 'forwardToPartners' },
];

export const actionTypeContentLibrary: ActionTypeContentLibrary = {
  forwardToPartners: ForwardToPartnersContent,
};

export const actionTypePayloadConfig: ActionTypePayloadConfig = {
  forwardToPartners: (values) => ({
    partnerIds: values.partnerIds,
  }),
};
